import { Validator } from '@vista-digital/validator';
import { OccSeatingShape, occSeatingShapeValidator } from './shape';
export const defaultOccSeatingRowLabelsConfig = {
    size: 25,
    margin: 8,
    shape: OccSeatingShape.Rectangle,
    borderRadius: 3,
    borderWidth: 0
};
export const occSeatingRowLabelsConfigValidator = Validator.object({
    size: Validator.number({ min: 0 }),
    margin: Validator.number({ min: 0 }),
    shape: occSeatingShapeValidator,
    borderRadius: Validator.number({ min: 0 }),
    borderWidth: Validator.number({ min: 0 })
});
//# sourceMappingURL=row-labels.js.map